// Thu Mar 27 06:04:36 GMT 2025

import * as models from "../crm-web-api-models"

export enum BonusRequestProp {
	BonusPaymentType = 'bonusPaymentType',
	BonusRequestType = 'bonusRequestType',
	CreatedBy = 'createdBy',
	CreationTime = 'creationTime',
	CustomerId = 'customerId',
	CustomerInteractionCountry = 'customerInteractionCountry',
	CustomerInteractionIp = 'customerInteractionIp',
	Description = 'description',
	ExpirationPeriod = 'expirationPeriod',
	Id = 'id',
	ModificationTime = 'modificationTime',
	ModifiedBy = 'modifiedBy',
	SourceAmount = 'sourceAmount',
	SourceCurrency = 'sourceCurrency',
	Status = 'status',
	TargetAmount = 'targetAmount',
	TargetCurrency = 'targetCurrency',
	TargetPoints = 'targetPoints',
	TradingAccount = 'tradingAccount',
	TransactionReason = 'transactionReason'
}

export type BonusRequestPropBonusPaymentType = {
	[BonusRequestProp.BonusPaymentType] : 'CASH' | 'PENDING' | 'REAL_MONEY' | null
}
export type BonusRequestPropBonusRequestType = {
	[BonusRequestProp.BonusRequestType] : 'MANUAL_BONUS' | 'PENDING_BONUS' | 'AUTOMATIC_BONUS' | 'COMPLIANCE_BONUS' | 'INSTANT_COMPLIANCE_BONUS' | 'ELIGIBLE_COMPLIANCE_BONUS' | 'SAS_PENDING_BONUS' | 'VERIFIED_ID_BONUS' | 'VERIFIED_RESIDENCE_BONUS' | 'FULL_REGISTRATION_BONUS' | 'COMPLETE_VERIFICATION_BONUS' | 'DEPOSIT_BONUS' | 'FIRST_DEPOSIT_BONUS' | 'EXTRA_FIRST_DEPOSIT_BONUS' | 'QUIZ_ASIC_BONUS' | 'WEB_TO_MOBILE_BONUS' | 'CUSTOMER_LEVEL_FIRST_DEPOSIT_BONUS' | 'FULL_REGISTRATION_CASH_BONUS' | null
}
export type BonusRequestPropCreatedBy = {
	[BonusRequestProp.CreatedBy] : models.UserDto
}
export type BonusRequestPropCreationTime = {
	[BonusRequestProp.CreationTime] : number | null
}
export type BonusRequestPropCustomerId = {
	[BonusRequestProp.CustomerId] : number | null
}
export type BonusRequestPropCustomerInteractionCountry = {
	[BonusRequestProp.CustomerInteractionCountry] : 'NA' | 'AFGHANISTAN' | 'ÅLAND_ISLANDS' | 'ALBANIA' | 'ALGERIA' | 'AMERICAN_SAMOA' | 'ANDORRA' | 'ANGOLA' | 'ANGUILLA' | 'ANTARCTICA' | 'ANTIGUA_AND_BARBUDA' | 'ARGENTINA' | 'ARMENIA' | 'ARUBA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BERMUDA' | 'BHUTAN' | 'BOLIVIA' | 'BONAIRE_SINT_EUSTATIUS_AND_SABA' | 'BOSNIA_AND_HERZEGOVINA' | 'BOTSWANA' | 'BOUVET_ISLAND' | 'BRAZIL' | 'BRITISH_INDIAN_OCEAN_TERRITORY' | 'BRUNEI_DARUSSALAM' | 'BULGARIA' | 'BURKINA_FASO' | 'BURUNDI' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CAPE_VERDE' | 'CAYMAN_ISLANDS' | 'CENTRAL_AFRICAN_REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'CHRISTMAS_ISLAND' | 'COCOS_ISLANDS' | 'COLOMBIA' | 'COMOROS' | 'CONGO' | 'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' | 'COOK_ISLANDS' | 'COSTA_RICA' | 'CROATIA' | 'CUBA' | 'CURAÇAO' | 'CYPRUS' | 'CZECH_REPUBLIC' | 'CÔTE_DIVOIRE' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN_REPUBLIC' | 'EAST_TIMOR' | 'ECUADOR' | 'EGYPT' | 'EL_SALVADOR' | 'EQUATORIAL_GUINEA' | 'ERITREA' | 'ESTONIA' | 'ETHIOPIA' | 'FALKLAND_ISLANDS' | 'FAROE_ISLANDS' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'FRENCH_GUIANA' | 'FRENCH_POLYNESIA' | 'FRENCH_SOUTHERN_TERRITORIES' | 'GABON' | 'GAMBIA' | 'Georgia' | 'GERMANY' | 'GHANA' | 'GIBRALTAR' | 'GREECE' | 'GREENLAND' | 'GRENADA' | 'GUADELOUPE' | 'GUAM' | 'GUATEMALA' | 'GUERNSEY' | 'GUINEA' | 'GUINEA_BISSAU' | 'GUYANA' | 'HAITI' | 'HEARD_ISLAND_AND_MCDONALD_ISLANDS' | 'HONDURAS' | 'HONG_KONG' | 'Hungary' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISLE_OF_MAN' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JERSEY' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'KOSOVO' | 'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' | 'KOREA_REPUBLIC_OF' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYAN' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MACAO' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL_ISLANDS' | 'MARTINIQUE' | 'MAURITANIA' | 'MAURITIUS' | 'MAYOTTE' | 'MEXICO' | 'MICRONESIA' | 'MOLDOVA_REPUBLIC_OF' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MONTSERRAT' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NETHERLANDS_ANTILLES' | 'NEW_CALEDONIA' | 'NEW_ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NIUE' | 'NORFOLK_ISLAND' | 'NORTHERN_MARIANA_ISLANDS' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PALESTINIAN_TERRITORY_OCCUPIED' | 'PANAMA' | 'PAPUA_NEW_GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'PITCAIRN' | 'POLAND' | 'PORTUGAL' | 'PUERTO_RICO' | 'QATAR' | 'ROMANIA' | 'RUSSIAN_FEDERATION' | 'RWANDA' | 'RÉUNION' | 'SAINT_BARTHÉLEMY_BL' | 'SAINT_HELENA' | 'SAINT_KITTS_AND_NEVIS' | 'SAINT_LUCIA' | 'SAINT_MARTIN_FRENCH_PART' | 'SAINT_PIERRE_AND_MIQUELON' | 'SAINT_VINCENT_AND_THE_GRENADINES' | 'SAMOA' | 'SAN_MARINO' | 'SAO_TOME_AND_PRINCIPE' | 'SAUDI_ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA_LEONE' | 'SINGAPORE' | 'SINT_MAARTEN_DUTCH_PART' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON_ISLANDS' | 'SOMALIA' | 'SOUTH_AFRICA' | 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' | 'SOUTH_SUDAN' | 'SPAIN' | 'SRI_LANKA' | 'SUDAN' | 'SURINAME' | 'SVALBARD_AND_JAN_MAYEN' | 'SWAZILAND' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIAN_ARAB_REPUBLIC' | 'TAIWAN' | 'TAJIKISTAN' | 'THAILAND' | 'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' | 'TOGO' | 'TOKELAU' | 'TONGA' | 'TRINIDAD_AND_TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TURKS_AND_CAICOS_ISLANDS' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED_ARAB_EMIRATES' | 'UNITED_KINGDOM' | 'UNITED_REPUBLIC_OF_TANZANIA' | 'UNITED_STATES_MINOR_OUTLYING_ISLANDS' | 'URUGUAY' | 'USA' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN_CITY_STATE' | 'VENEZUELA' | 'VIET_NAM' | 'VIRGIN_ISLANDS_GB' | 'VIRGIN_ISLANDS_USA' | 'WALLIS_AND_FUTUNA' | 'WESTERN_SAHARA' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE' | null
}
export type BonusRequestPropCustomerInteractionIp = {
	[BonusRequestProp.CustomerInteractionIp] : string | null
}
export type BonusRequestPropDescription = {
	[BonusRequestProp.Description] : string | null
}
export type BonusRequestPropExpirationPeriod = {
	[BonusRequestProp.ExpirationPeriod] : number | null
}
export type BonusRequestPropId = {
	[BonusRequestProp.Id] : number
}
export type BonusRequestPropModificationTime = {
	[BonusRequestProp.ModificationTime] : number | null
}
export type BonusRequestPropModifiedBy = {
	[BonusRequestProp.ModifiedBy] : models.UserDto
}
export type BonusRequestPropSourceAmount = {
	[BonusRequestProp.SourceAmount] : number | null
}
export type BonusRequestPropSourceCurrency = {
	[BonusRequestProp.SourceCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type BonusRequestPropStatus = {
	[BonusRequestProp.Status] : 'ON_HOLD' | 'DECLINED' | 'ACCEPTED' | 'PENDING_DEPOSIT' | null
}
export type BonusRequestPropTargetAmount = {
	[BonusRequestProp.TargetAmount] : number | null
}
export type BonusRequestPropTargetCurrency = {
	[BonusRequestProp.TargetCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type BonusRequestPropTargetPoints = {
	[BonusRequestProp.TargetPoints] : number | null
}
export type BonusRequestPropTradingAccount = {
	[BonusRequestProp.TradingAccount] : models.DefaultEntityDto | null
}
export type BonusRequestPropTransactionReason = {
	[BonusRequestProp.TransactionReason] : models.DefaultEntityDto | null
}


export type BonusRequest = 
	BonusRequestPropBonusPaymentType & 
	BonusRequestPropBonusRequestType & 
	BonusRequestPropCreatedBy & 
	BonusRequestPropCreationTime & 
	BonusRequestPropCustomerId & 
	BonusRequestPropCustomerInteractionCountry & 
	BonusRequestPropCustomerInteractionIp & 
	BonusRequestPropDescription & 
	BonusRequestPropExpirationPeriod & 
	BonusRequestPropId & 
	BonusRequestPropModificationTime & 
	BonusRequestPropModifiedBy & 
	BonusRequestPropSourceAmount & 
	BonusRequestPropSourceCurrency & 
	BonusRequestPropStatus & 
	BonusRequestPropTargetAmount & 
	BonusRequestPropTargetCurrency & 
	BonusRequestPropTargetPoints & 
	BonusRequestPropTradingAccount & 
	BonusRequestPropTransactionReason

export const BONUS_REQUEST_PROPERTY_NAMES = Object.freeze([BonusRequestProp.BonusPaymentType, BonusRequestProp.BonusRequestType, BonusRequestProp.CreatedBy, BonusRequestProp.CreationTime, BonusRequestProp.CustomerId, BonusRequestProp.CustomerInteractionCountry, BonusRequestProp.CustomerInteractionIp, BonusRequestProp.Description, BonusRequestProp.ExpirationPeriod, BonusRequestProp.Id, BonusRequestProp.ModificationTime, BonusRequestProp.ModifiedBy, BonusRequestProp.SourceAmount, BonusRequestProp.SourceCurrency, BonusRequestProp.Status, BonusRequestProp.TargetAmount, BonusRequestProp.TargetCurrency, BonusRequestProp.TargetPoints, BonusRequestProp.TradingAccount, BonusRequestProp.TransactionReason])

export type BonusRequestPreview = 
	BonusRequestPropId & 
	BonusRequestPropCreationTime & 
	BonusRequestPropCreatedBy & 
	BonusRequestPropModificationTime & 
	BonusRequestPropModifiedBy & 
	BonusRequestPropTradingAccount & 
	BonusRequestPropExpirationPeriod & 
	BonusRequestPropStatus & 
	BonusRequestPropBonusRequestType & 
	BonusRequestPropBonusPaymentType & 
	BonusRequestPropTransactionReason & 
	BonusRequestPropSourceAmount & 
	BonusRequestPropSourceCurrency & 
	BonusRequestPropTargetAmount & 
	BonusRequestPropTargetCurrency & 
	BonusRequestPropTargetPoints & 
	BonusRequestPropCustomerInteractionIp & 
	BonusRequestPropCustomerInteractionCountry & 
	BonusRequestPropDescription

export const BONUS_REQUEST_PREVIEW_PROPERTY_NAMES = Object.freeze([BonusRequestProp.Id, BonusRequestProp.CreationTime, BonusRequestProp.CreatedBy, BonusRequestProp.ModificationTime, BonusRequestProp.ModifiedBy, BonusRequestProp.TradingAccount, BonusRequestProp.ExpirationPeriod, BonusRequestProp.Status, BonusRequestProp.BonusRequestType, BonusRequestProp.BonusPaymentType, BonusRequestProp.TransactionReason, BonusRequestProp.SourceAmount, BonusRequestProp.SourceCurrency, BonusRequestProp.TargetAmount, BonusRequestProp.TargetCurrency, BonusRequestProp.TargetPoints, BonusRequestProp.CustomerInteractionIp, BonusRequestProp.CustomerInteractionCountry, BonusRequestProp.Description])

export type BonusRequestHistoryTab = 
	BonusRequestPropId & 
	BonusRequestPropCustomerId & 
	BonusRequestPropStatus & 
	BonusRequestPropBonusRequestType

export const BONUS_REQUEST_HISTORY_TAB_PROPERTY_NAMES = Object.freeze([BonusRequestProp.Id, BonusRequestProp.CustomerId, BonusRequestProp.Status, BonusRequestProp.BonusRequestType])
